/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import router from '../router'
import store from '../store'
import { createIntl } from 'vue-intl'
const intl = createIntl({
	locale: 'pt-BR',
	defaultLocale: 'pt-BR'
});

export function registerPlugins (app) {
  app
    .use(vuetify)
    .use(router)
    .use(store)
    .use(intl)
}
